<template>
  <!-- The provider doesn't render anything, just provides theme context -->
  <slot></slot>
</template>

<script setup lang="ts">
import { provide, onMounted } from 'vue';
import { useTheme } from '@/composables/useTheme';
import { THEME_KEY } from '@/constants/theme';

// Set up theme and provide it to all child components
const themeContext = useTheme();
provide(THEME_KEY, themeContext);

// Initialize theme immediately during component creation
// This ensures theme is applied as early as possible, before mounting
const { isDark } = themeContext;
if (typeof window !== 'undefined') {
  if (isDark.value) {
    document.documentElement.classList.add('dark');
    document.documentElement.classList.remove('light');
  } else {
    document.documentElement.classList.add('light');
    document.documentElement.classList.remove('dark');
  }
}

// Making sure theme is correctly applied again when component is mounted
onMounted(() => {
  // Force theme update on mount as well
  if (isDark.value) {
    document.documentElement.classList.add('dark');
    document.documentElement.classList.remove('light');
  } else {
    document.documentElement.classList.add('light');
    document.documentElement.classList.remove('dark');
  }
})
</script>